namespace SorAraBul.PropertyManagement {
    export interface TenantsRow {
        Id?: number;
        PropertyId?: number;
        Name?: string;
        Surname?: string;
        Phone?: string;
        Email?: string;
        SmsVerificationCode?: number;
        Status?: TenantStatus;
        ReportUrl?: string;
        Rating?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        LastActionDate?: string;
        Link?: string;
        TenantDetailGId?: string;
        SorsLocalReportUrl?: string;
        CompanyId?: number;
        PropertyPropertyType?: number;
        PropertyPropertyName?: string;
        PropertyFullName?: string;
        PropertyAddress?: string;
        PropertyImages?: string;
        PropertyRequestedRentAmount?: number;
        PhoneNumeric?: string;
        NameSurname?: string;
    }

    export namespace TenantsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'PropertyManagement.Tenants';
        export const deletePermission = 'Tenants:Delete';
        export const insertPermission = 'Tenants:Insert';
        export const readPermission = 'Tenants:View';
        export const updatePermission = 'Tenants:Update';

        export declare const enum Fields {
            Id = "Id",
            PropertyId = "PropertyId",
            Name = "Name",
            Surname = "Surname",
            Phone = "Phone",
            Email = "Email",
            SmsVerificationCode = "SmsVerificationCode",
            Status = "Status",
            ReportUrl = "ReportUrl",
            Rating = "Rating",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            LastActionDate = "LastActionDate",
            Link = "Link",
            TenantDetailGId = "TenantDetailGId",
            SorsLocalReportUrl = "SorsLocalReportUrl",
            CompanyId = "CompanyId",
            PropertyPropertyType = "PropertyPropertyType",
            PropertyPropertyName = "PropertyPropertyName",
            PropertyFullName = "PropertyFullName",
            PropertyAddress = "PropertyAddress",
            PropertyImages = "PropertyImages",
            PropertyRequestedRentAmount = "PropertyRequestedRentAmount",
            PhoneNumeric = "PhoneNumeric",
            NameSurname = "NameSurname"
        }
    }
}
